import ES6Promise from 'es6-promise'
ES6Promise.polyfill()
import Vue from 'vue'
import App from './App.vue'
import './directives'
import store from './store/store'
import router from './router/router'
import VueResource from 'vue-resource'
import '../node_modules/bulma/css/bulma.css'
import '../static/css/backgroundColor.css'
import VModal from 'vue-js-modal'
import swal from 'sweetalert2'

import './common/inputs'
import './common/buttons'

import '../static/css/web-angular/smart-select.css'
import '../static/css/web-angular/button3d.css'
import '../static/css/web-angular/style.css'

Vue.use(VModal)
Vue.use(VueResource)

const swalPlugin = {}

swalPlugin.install = function (Vue) { Vue.prototype.$swal = swal }

Vue.use(swalPlugin)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
